import axios from "axios";

const reportedErrors = new WeakSet<object>();

export function isAbortError(error: unknown): boolean {
  if (error instanceof DOMException && error.name === "AbortError") {
    return true;
  }
  if (axios.isCancel(error)) {
    return true;
  }
  return false;
}

export function formatApiErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    if (error.code === "ECONNABORTED" || /timeout/i.test(error.message)) {
      return "The request timed out. Please try again.";
    }

    if (error.response) {
      // const { status, data } = error.response;
      const { data } = error.response;
      if (typeof data === "string" && data.trim()) {
        return data;
      }
      if (data && typeof data === "object") {
        const record = data as Record<string, unknown>;
        const detail =
          record.message ??
          record.Message ??
          record.error ??
          record.Error ??
          record.title;
        if (typeof detail === "string" && detail.trim()) {
          return detail;
        }
      }
      // return `Request failed (${status}). Please try again.`;
      return `Please try again.`;
    }

    if (error.request) {
      // return "Network error. Please check your connection and try again.";
      return "Please try again.";
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  return "We couldn't complete your request, please try again in a few moments";
}

export function reportApiError(error: unknown): void {
  if (isAbortError(error)) {
    return;
  }

  if (error && typeof error === "object") {
    if (reportedErrors.has(error)) {
      return;
    }
    reportedErrors.add(error);
  }

  const message = formatApiErrorMessage(error);
  errorPopupHandler?.(message);
}

type ErrorPopupHandler = (message: string) => void;

let errorPopupHandler: ErrorPopupHandler | null = null;

export function registerErrorPopupHandler(handler: ErrorPopupHandler | null): void {
  errorPopupHandler = handler;
}
